<div class="diagnostics-container">
  <h2>Connectivity Test</h2>

  <div class="test-info">
    <p>Testing connectivity to: <strong>{{ target }}</strong></p>

    @if (isDevEnvironment) {
    <p class="dev-notice">Note: Port 2375 is closed by default in dev for testing purpose.</p>
    }

    <button
      kendoButton
      [primary]="true"
      (click)="runTests()"
    >
      Run Connectivity Test
    </button>
  </div>

  <div class="results-container">
    <div class="results-header">
      <div class="header-port">Port</div>
      <div class="header-status">Status</div>
      <div class="header-details">Details</div>
    </div>

    <div class="results-list">
      @for (result of testResults; track result.port) {
      <div class="result-row">
        <div class="port-cell">
          <span class="port-number">{{ result.port }}</span>
        </div>

        <div class="status-cell" [class.pending]="result.status === 'pending'">
          @if (result.status === 'pending') {
          <div class="progress-background">
            <div class="progress-fill" [style.width.%]="result.progress || 0"></div>
          </div>
          }
          <div class="status-content">
            @if (result.status === 'pending') {
            <kendo-loader [type]="'infinite-spinner'" [themeColor]="'info'" [size]="'small'">
            </kendo-loader>
            }
            @if (result.status === 'success') {
            <kendo-icon [name]="'check-circle'" [themeColor]="'success'"></kendo-icon>
            }
            @if (result.status === 'error') {
            <kendo-icon [name]="'x-circle'" [themeColor]="'error'"></kendo-icon>
            }
            <span class="status-text">{{ getStatusText(result.status) }}</span>
          </div>
        </div>

        <div class="details-cell" [class.has-error]="result.error">
          @if (!result.error && !result.details) {
          <span class="no-error">-</span>
          }
          @if (result.details) {
          <span class="success-details">{{ result.details }}</span>
          }
          @if (result.error) {
          <div class="error-details">
            <button class="error-toggle" (click)="result.expanded = !result.expanded">
              <kendo-icon [name]="result.expanded ? 'chevron-up' : 'chevron-down'"></kendo-icon>
              View Details
            </button>
            @if (result.expanded) {
            <pre class="error-text">{{ result.error }}</pre>
            }
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

</div>
